<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
    <v-card class="px-3 py-0">
    <v-card-title>
        <v-col>
            <v-row class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon dark @click="close()">
                    <v-icon color="primary">mdi-close</v-icon>
                </v-btn>
                <v-col class="pt-0 pb-0 text-center" cols="12">
                    <h1>Inserir dados extras {{ tituloPorTipo[tipo] }}</h1>
                    <span style="font-size:16px;font-weight:normal" v-if="tipo=='guias'">{{itemSelecionado.nome_beneficiario}}</span>
                    <span style="font-size:16px;font-weight:normal" v-else-if="tipo=='itens'">{{itemSelecionado.descricao_procedimento}}</span>
                </v-col>
            </v-row>
            
            <v-row  wrap class="ma-0" v-if="tipo=='guias'">
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Ident. prestador:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.identificador_prestador_captura}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. lote:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_lote}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. guia prestador: </span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_guia_prestador}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. carteirinha: </span>
                <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.carteira_beneficiario}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Valor do recurso: </span>
                <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.valor_recursado | formatPrice }}</span>
            </v-col>
            </v-row>
            <v-row  wrap class="ma-0" v-else-if="tipo=='itens'">
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Ident. prestador:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.identificador_prestador_captura}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. lote:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_lote}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. guia prestador: </span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_guia_prestador}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Data execução: </span>
                <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.data_execucao | formatDate}}</span>
            </v-col>
            </v-row>
            <v-row>
              <v-alert v-show="!condicao" dense text type="error" icon="fa fa-exclamation-triangle" width="100%">
          Não é possível salvar as informações! Preencha todos o campos obrigatórios destacados.
        </v-alert>
            </v-row>
        </v-col>
    </v-card-title>
    <v-card-text>
      
      <formDadosExtras
        :itemSelecionado="itemSelecionado"
        tipo="Recurso"
        :dadosExtrasConfig="dadosExtrasConfig"
        :grupoEconomico="grupoEconomico"
        :dialog="dialog"
        :retornoForm="(condi) => retornoFormData(condi)"
        :formDataPre="formDataPre"
        :reapresentacao="reapresentacao"
        idForm="FormRecurso"
      />
      <formDadosExtras
        v-if="reapresentacao"
        :itemSelecionado="itemSelecionado"
        tipo="Reapresentacao"
        :dadosExtrasConfig="dadosExtrasConfig"
        :grupoEconomico="grupoEconomico"
        :dialog="dialog"
        :retornoForm="(condi) => retornoFormData(condi)"
        :formDataPre="formDataPre"
        :reapresentacao="reapresentacao"
        :validarFormulario="validarFormulario"
        idForm="FormReapresentacao"
      />
      </v-card-text>
      <v-card-actions class="px-9">
            <v-btn
            outlined
                color="primary"
                height="30px"
                small
                depressed
                @click="close()"
            >
                Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                height="30px"
                small
                depressed
                @click="enviarDados()"
            >
                Atualizar
            </v-btn>
        </v-card-actions>
    </v-card> 
    
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import formDadosExtras from "@/components/recebiveis/recursos_de_glosa_edicao/formDadosExtras"
moment.locale("pt-BR");
export default {
  components:{
    formDadosExtras
  },
  
  data() {
    return {
      tituloPorTipo: {
          guias: "da guia",
          itens: "do item",
      },
      condicao: true,
      dadosExtrasPorTipo:{ Recurso:[]},
      validarFormulario: false
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  watch: {
    dialog(){
      this.validarFormulario = false
      this.condicao = true
    }
  },
  methods: {
    retornoFormData(condi){
      this.condicao = condi;
    },
    enviarDados(){
      this.validarFormulario = true;
      setTimeout(()=>{
          if(this.condicao)
          {
            this.salvaDados()
            this.validarFormulario =  false;
          }
        }, 100)
    },
    salvaDados(){
      let dadoC = JSON.stringify(this.formDataPre).replaceAll('Nome', '@Nome').replaceAll('Valor', '@Valor')
      
      let payload = { grupo_economico: this.grupoEconomico, obj_type: this.tipo, dados_extras: dadoC, pagamento_id: this.itemSelecionado.pagamento_id, id: this.itemSelecionado.id};
      
      let obj = { query: [ { modulo: "Recebiveis", acao: "salvadadosextrasedicao", payload: payload, }, ], }; 
      this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }

          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: "Todos salvos com sucesso",
            callback: () => { this.itemSelecionado.dados_extras = dadoC; this.close()},
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("hideLoader");
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
  },
  props: {
    close: Function,
    dadosExtrasConfig: Object,
    dialog: Boolean,
    formDataPre: Object,
    grupoEconomico: Number,
    itemSelecionado: Object,
    tipo: String,
    reapresentacao: Boolean
  },
}
</script>

<style>

</style>